import { defineMessages } from "react-intl";

export const messages = defineMessages({
    defaultDownloadName: {
        id: "analyze.defaultDownloadName",
        defaultMessage: "analyzeResult",
    },
    question1: {
        id: "analyze.question1",
        defaultMessage: "What Fields have a soil nutrient deficiency?",
    },
    question2: {
        id: "analyze.question2",
        defaultMessage:
            "What Fields are deficient in the same nutrient in both soil and tissue tests?",
    },
    question3: {
        id: "analyze.question3",
        defaultMessage:
            "What Fields are deficient in tissue test but not soil test of the same nutrient?",
    },
    question4: {
        id: "analyze.question4",
        defaultMessage: "How did planter performance impact yield?",
    },
    question5: {
        id: "analyze.question5",
        defaultMessage: "How are soil test results trending on the selected Fields?",
    },
    question6: {
        id: "analyze.question6",
        defaultMessage: "How are soil test results trending on the selected Fields? (Summary)",
    },
    aiWarning: {
        id: "analyze.aiWarning",
        defaultMessage: "* Analyze uses AI and can make mistakes.",
    },
    result: {
        id: "analyze.result",
        defaultMessage: "Analysis Result:",
    },
    select: {
        id: "analyze.select",
        defaultMessage: "Select Analysis:",
    },
});

export const creditMessages = defineMessages({
    creditsUsedToday: {
        id: "analyze.creditsUsedToday",
        defaultMessage: "{current} / {limit} credits used today",
    },
    creditLimitReachedTitle: {
        id: "analyze.creditLimitReachedTitle",
        defaultMessage: "Credit Limit Reached",
    },
    creditLimitReachedMessage: {
        id: "analyze.creditLimitReachedMessage",
        defaultMessage:
            "You have reached your daily analysis credit limit. Please try again tomorrow.",
    },
});

export const errorMessages = defineMessages({
    invalidSelectionError: {
        id: "analyze.invalidSelectionError",
        defaultMessage: "Please select an Analysis type and at least 1 Field.",
    },
    invalidSelectionModalTitle: {
        id: "analyze.invalidSelectionModalTitle",
        defaultMessage: "Required",
    },
    invalidFieldsWarning: {
        id: "analyze.invalidFieldsWarning",
        defaultMessage:
            "The following Fields do not have the required data to be included in this Analysis:{fieldsText}",
    },
    invalidFieldsModalTitle: {
        id: "analyze.invalidFieldsModalTitle",
        defaultMessage: "Validation Errors",
    },
    genericModalTitle: {
        id: "analyze.genericModalTitle",
        defaultMessage: "Error",
    },
    generic: {
        id: "analyze.generic",
        defaultMessage: "An unexpected error has occurred in the analyze API",
    },
});
